// extracted by mini-css-extract-plugin
export default {"closeButton":"close-button_closeButton__MNpBi"};